import React from "react";
import { Grid } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from "@mui/material/styles";
import useStore from "../../store";
import { PTMDialog } from "../../Components";

const StyledPTMDialog = styled(PTMDialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: "0 !important",
    },
    "& .MuiPaper-root": {
        border: "none !important",
    },
    "& .MuiDivider-root": {
        display: "none",
    },
    ".dialog-title": {
        background: `linear-gradient(to right, ${theme.palette.primary.dark}, ${theme.palette.primary.main} )`,
        color: "black",
        fontSize: 30,
        padding: 20,
        cursor: "pointer",
        "& img": {
            height: 90,
        },
        "& p": {
            paddingLeft: 5,
        },
    },
    ".sub-title": {
        fontSize: 25,
        marginBottom: 0,
    },
    ".dialog-body": {
        padding: 15,
        "& svg.svg-inline--fa": {
            color: theme.palette.primary.dark,
            marginRight: 5,
        },
    },
}));

export default function About() {
    const currentDialog = useStore((store) => store.dashboard.dialogs.currentOpenDialog);
    const setDialog = useStore((store) => store.dashboard.dialogs.setCurrentOpenDialog);
    const appInfo = useStore((store) => store.app.appInfo);

    return (
        <StyledPTMDialog
            open={currentDialog === "about"}
            onClose={() => setDialog("")}
            appBarStyle={{ display: "none" }}
            everywhereVisible
        >
            <div className="dialog-title drag-handle ptm-dialog-draggable">
                <Grid container alignItems="center">
                    <Grid container item xs={4} justifiyContent="center">
                        {/* eslint-disable-next-line no-underscore-dangle */}
                        <img src={appInfo.custom_icon_enabled && appInfo.__custom_icon_exists ? "./public/assets/custom_icon/pti.png" : "./static/pti.png"} alt="icon" />
                    </Grid>
                    <Grid iem xs={8}>
                        <p>{appInfo.title}</p>
                        <p className="sub-title">
                            Desktopversion
                            {" "}
                            {appInfo.version}
                        </p>
                        <p className="sub-title">
                            Mobileversion
                            {" "}
                            1.0.3
                        </p>
                    </Grid>
                </Grid>
            </div>
            <hr style={{ margin: 0 }} />
            <div className="dialog-body">
                <h5><b>Eine Entwicklung der:</b></h5>
                <p>
                    {" "}
                    <FontAwesomeIcon icon="building" />
                    {" "}
                    Porthun & Thiede Softwareentwicklungs- und Schulungs GmbH
                </p>
                <p>
                    {" "}
                    <FontAwesomeIcon icon="map" />
                    {" "}
                    Wismarsche Straße 323a
                </p>
                <p>
                    {" "}
                    <FontAwesomeIcon icon="globe" />
                    19055 Schwerin
                </p>
                <p>
                    {" "}
                    <FontAwesomeIcon icon="phone" />
                    {" "}
                    Tel.: +49 385 5958690
                </p>
                {/* <p> */}
                {/*     {" "} */}
                {/*     <FontAwesomeIcon icon="fax" /> */}
                {/*     Fax: +49 385 5958699 */}
                {/* </p> */}
                <p>
                    {" "}
                    <FontAwesomeIcon icon="envelope" />
                    {" "}
                    E-Mail: info@pt-systemhaus.de
                </p>
            </div>
        </StyledPTMDialog>

    );
}
